import SelfShipping from './SelfShipping';
import { withI18n } from 'react-i18next';

export default withI18n()(SelfShipping);
